import { Loader } from "lucide-react";
import { FC } from "react";
import { useLoader } from "@/contexts/LoaderProvider";

interface CLoaderProps {}

const CLoader: FC<CLoaderProps> = () => {
  const { isLoading } = useLoader();
  return (
    <>
      {isLoading ? (
        <div className="fixed w-screen h-screen top-0 bottom-0 left-0 right-0 flex justify-center items-center z-50 bg-black bg-opacity-50 text-white after:transition after:ease-out after:duration-1000">
          <div className="flex justify-center items-center gap-3">
            <Loader className="mr-2 animate-spin w-5 h-6" />
            Loading...
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CLoader;
